
import axios from "axios";

const VisitingCardService = {
  create: (data) => {
    const API_URL =
      sessionStorage.getItem("APIUrl") + "/api/VisitingCard";

    return axios.post(API_URL, data);
  },
};

export default VisitingCardService;